"use client";

import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";

const SearchProvider = dynamic(() =>
  import("@/context/searchContext").then((module) => module.SearchProvider)
);

export const shouldUseSearchProvider = (pathname: string | null) =>
  pathname === "/search" ||
  pathname?.startsWith("/search/vendor/") === true ||
  pathname?.startsWith("/brands/") === true;

type SearchProviderBoundaryProps = {
  children: React.ReactNode;
};

/**
 * Search state is only needed by listing/search routes. Keeping this boundary
 * around the route content lets the navbar use the lightweight filters store
 * without loading the full search orchestration on public pages.
 */
export default function SearchProviderBoundary({ children }: SearchProviderBoundaryProps) {
  const pathname = usePathname();

  if (!shouldUseSearchProvider(pathname)) {
    return children;
  }

  return <SearchProvider>{children}</SearchProvider>;
}
